import IpsDatePicker from './IpsDatePicker.vue';
import '../../../styles/custom.scss';

export default IpsDatePicker;
